import { SetGlobalPayCredentialsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useSetGlobalPayCredentials() {
  const [saving, setSaving] = useState(false);

  async function setGlobalPayCredentials(request: SetGlobalPayCredentialsRequest) {
    try {
      setSaving(true);
      const res = await api.postSetGlobalPayCredentials(request);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSaving(false);
    }
  }

  return { saving, setGlobalPayCredentials };
}
